/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileLastScanDateModel } from '../../models/profile-last-scan-date-model';

export interface ProfileLastScanDatePersonIdGet$Params {

/**
 * The unique identifier of the person (MPI person id).
 */
  personId: string;
}

export function profileLastScanDatePersonIdGet(http: HttpClient, rootUrl: string, params: ProfileLastScanDatePersonIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ProfileLastScanDateModel>> {
  const rb = new RequestBuilder(rootUrl, profileLastScanDatePersonIdGet.PATH, 'get');
  if (params) {
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ProfileLastScanDateModel>;
    })
  );
}

profileLastScanDatePersonIdGet.PATH = '/Profile/LastScanDate/{personId}';
